import { Injectable } from "@angular/core";
import { UserDataService } from "../data-service/user.data.service";
import { UserProfileInterface } from "../interface/user.interface";

@Injectable({
  providedIn: "root"
})
export class UserService {
  user: UserProfileInterface;

  constructor(private userDataService: UserDataService) {}

  async updateProfile(): Promise<void> {
    this.user = await this.userDataService.getProfile();
  }

  setToken(rights: any) {
    localStorage.setItem("getTokenFunctionClaims", rights.getTokenFunctionClaims);
    localStorage.setItem("getTokenProductClaims", rights.getTokenProductClaims);
    localStorage.setItem("getTokenScreenClaims", rights.getTokenScreenClaims);
    localStorage.setItem("getTokenUserAccessRightClaims", rights.getTokenUserAccessRightClaims);
  }

  getToken() {
    return {
      functionClaims: localStorage.getItem('getTokenFunctionClaims'),
      productClaims: localStorage.getItem('getTokenProductClaims'),
      screenClaims: localStorage.getItem('getTokenScreenClaims'),
      userAccessRightClaims: localStorage.getItem('getTokenUserAccessRightClaims')
    }
  }
}
